import VonalkodAdatlapTableService from 'app/admin/vonalkodadatlap/service/VonalkodAdatlapTableService';
import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';

const config = {
	key: 'vonalkodAdatlapTable',
	text: 'Vonalkod Adatlap',
	textKey: 'chapters',
	service: VonalkodAdatlapTableService,
	icon: 'person',
	editFormState: item => `/vonalkodadatlap/edit/${item ? item.id : 'new'}`,
	toolbarAction: ['filter', 'refresh', 'new'],
	filterFields: [
		{
			propertyName: 'csomagNev',
			propertyType: 'String',
			type: 'LIKE'
		}
	],
	rowAction: ['modify', 'delete'],
	columns: [
		{
			key: 'csomagNev',
			text: 'Csomag neve',
			textKey: 'csomagNev',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'feltoltoAdatlapNev',
			text: 'Feltöltő',
			textKey: 'feltoltoAdatlapNev',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'vizsgaVonalkod',
			text: 'Vizsga vonalkódja',
			textKey: 'vizsgaVonalkod',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'vonalkod',
			text: 'Vizsgázó vonalkód',
			textKey: 'vonalkod',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'hibaXML',
			text: 'Hiba',
			textKey: 'hibaXML',
			type: 'text',
			sortable: true,
			disablePadding: false
		}
	]
};

function VonalkodAdatlapTable() {
	return <TableBrowser config={config} />;
}

export default withReducer('vonalkodAdatlapTable', reducer('vonalkodAdatlapTable'))(VonalkodAdatlapTable);
